import { render, staticRenderFns } from "./GeneralSettingContactAddressRegion.vue?vue&type=template&id=522252be&"
import script from "./GeneralSettingContactAddressRegion.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactAddressRegion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports